import React, { FC, useContext, useEffect, useState } from "react"
import ConfirmServiceInvite from "../../../components/services/ConfirmServiceInvite"
import EnrollInService from "../../../components/services/EnrollInService"
import InviteSent from "../../InviteSent"
import InviteToService from "../../../components/services/InviteToService"
import useLoading from "../../../hooks/useLoading"
import useScrollToTop from "../../../hooks/useScrollToTop"
import { ContactRequests } from "../../../api/app.service"
import { useLocation, useNavigate } from "react-router-dom"
import { UserCtx } from "../../../context/userContext"
import { useToast } from "../../../hooks/useToast"

type Props = {
  contact: any
}

const ContactServicesFlow: FC<Props> = ({ contact }) => {
  const [confirmServiceInvite, setConfirmServiceInvite] = useState<any>(null)
  const [inviteToService, setInviteToService] = useState<boolean>(false)
  const [enrollInService, setEnrollInService] = useState<boolean>(false)
  const [inviteSent, setInviteSent] = useState<boolean>(false)
  const [activeContact, setActiveContact] = useState<any>(null)
  const { user } = useContext(UserCtx)
  const { startLoading, stopLoading } = useLoading()
  const { toast } = useToast()
  const location: any = useLocation()
  const navigate = useNavigate()

  // Logic for enroll in service click originating from ServicesPreviewElement.tsx
  let service: any
  if (location && location.state) {
    service = location.state.service
  }
  useEffect(() => {
    if (service && activeContact) {
      navigate(
        `/${user.activeProfile}/contacts/${activeContact?.profile_id}/services/${service.service_id}`,
        {
          state: { service: service, contact: activeContact },
        }
      )
    }
  }, [service, activeContact])

  const getServiceOwnerContact = (profileIdToMatch: number) => {
    if (user?.coachProfile || user?.memberProfile) {
      startLoading()
      ContactRequests.getContactList({
        profile_id: user.activeProfileId,
        profile_type: user.activeProfile,
      })
        .then((data) => {
          const foundContact = data.contact_list.find(
            (contact: any) => contact.profile_id === profileIdToMatch
          )
          setActiveContact(foundContact)
          stopLoading()
        })
        .catch((ex) => {
          console.error(ex)
          toast.error(ex.response.data.message)
          stopLoading()
        })
    }
  }

  // Logic for setting InviteToService or EnrollInService based on active profile
  useEffect(() => {
    user.activeProfile === "coach"
      ? setInviteToService(true)
      : setEnrollInService(true)

    // Logic for handling hard refresh or direct link to .../profile_id/services
    // Fetches contact info from db only if it was not passed from DynamicContactProfile
    if (!contact) {
      const profileId = parseInt(location.pathname.split("/")[3])
      getServiceOwnerContact(profileId)
    } else {
      setActiveContact(contact)
    }
  }, [])

  useScrollToTop()

  return (
    <div className="">
      {inviteSent && <InviteSent setInviteSent={setInviteSent} />}
      {activeContact && confirmServiceInvite && (
        <ConfirmServiceInvite
          confirmServiceInvite={confirmServiceInvite}
          setConfirmServiceInvite={setConfirmServiceInvite}
          selectedContact={activeContact}
          setInviteToService={setInviteToService}
        />
      )}
      {activeContact && inviteToService && (
        <InviteToService
          setInviteToService={setInviteToService}
          setConfirmServiceInvite={setConfirmServiceInvite}
        />
      )}
      {activeContact && enrollInService && (
        <EnrollInService contact={activeContact} />
      )}
    </div>
  )
}

export default ContactServicesFlow
